export const START_CHANNEL = 'START_CHANNEL';
export const STOP_CHANNEL = 'STOP_CHANNEL';
export const CHANNEL_ON = 'CHANNEL_ON';
export const CHANNEL_OFF = 'CHANNEL_OFF';
export const SERVER_ON = 'SERVER_ON';
export const SERVER_OFF = 'SERVER_OFF';
export const SOCKET_READY = 'SOCKET_READY';
export const SET_REG_SYMBOL = 'SET_REG_SYMBOL';
export const UNSET_REG_SYMBOL = 'UNSET_REG_SYMBOL';

export const RECEIVE_3210 = 'RECEIVE_3210';
export const RECEIVE_3220 = 'RECEIVE_3220';
export const RECEIVE_3223 = 'RECEIVE_3223';
export const RECEIVE_3211 = 'RECEIVE_3211';
export const RECEIVE_3310 = 'RECEIVE_3310';
export const RECEIVE_3250 = 'RECEIVE_3250';
export const RECEIVE_1101 = 'RECEIVE_1101';

export const REGISTER_SOCKET_DATA = 'REGISTER_SOCKET_DATA';
export const LEAVE_SOCKET_DATA = 'LEAVE_SOCKET_DATA';

export const REG_PRIVATE_SOCKET = 'REG_PRIVATE_SOCKET';
export const REG_PRIVATE_SOCKET_DATA = 'REG_PRIVATE_SOCKET_DATA';

export const ListAccount = 'ListAccount';
export const DefaultAccount = 'DefaultAccount';
export const NewOrder = 'NewOrder';
export const PurchasePower = 'PurchasePower';
export const StockBalance = 'StockBalance';
export const OrderList = 'OrderList';
export const ListOrder = 'ListOrder';
export const GetMatchOrder = 'GetMatchOrder';
export const CancelOrder = 'CancelOrder';
export const EditOrder = 'EditOrder';
export const CashBalance = 'CashBalance';
export const ShareBalance = 'ShareBalance';
export const getPositions = 'getPositions';
export const getAvailStockList = 'getAvailStockList';
export const getSymbolInfo = 'getSymbolInfo';

export const Event = 'Event';
